import qs from "qs";
import axios from "axios";
import util from "../../../util";

const login = ({commit}, payload) => {
  var url = 'oauth/token'
  var data = qs.stringify({
    'grant_type': 'password', 'username': payload.credentials.username,
    'password': payload.credentials.password, withCredentials: true
  })
  console.log(data)
  let encoded = btoa("webapp:filekom2018");

  var headers = {
    'Authorization': 'Basic ' + encoded,
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json'
  }

  return new Promise((resolve, reject) => {

    const axiosLogin = axios.create({
      baseURL: payload.context.$endpoint,
      timeout: 600000,
    })

    axiosLogin.post(url, data, {headers})
      .then((response) => {

        localStorage.setItem("token", response.data.access_token);
        commit('setToken', {token: response.data.access_token});

        const auth = util.getAuth()

        //Cargando Data Inicial en cache
        payload.context.axios.get('api/initialData', {'headers': util.getAuthHeader()}).then((response) => {

          localStorage.setItem("menus", JSON.stringify(response.data.menus))
          localStorage.setItem("user", JSON.stringify(response.data.user))
          localStorage.setItem("access", JSON.stringify(auth.access))
          localStorage.setItem("clients", JSON.stringify(response.data.clients))
          localStorage.setItem("location", JSON.stringify(response.data.location))
          localStorage.setItem("billingServices", JSON.stringify(response.data.billingServices))
          localStorage.setItem("servicesTariffDefault", JSON.stringify(response.data.servicesTariffDefault))
          localStorage.setItem("departaments", JSON.stringify(response.data.departaments))
          localStorage.setItem("provinces", JSON.stringify(response.data.provinces))
          localStorage.setItem("districts", JSON.stringify(response.data.districts))
          commit('setUser', response.data.user)
          commit('setAccess', auth.access)

          resolve();

        }).catch(error => {
          if (error.response) {
            console.log(error.response)
            reject(error.response)
          }
          reject()
        });

      })
      .catch((error) => {

        if (!error.response) {
          util.showDialogError(payload.context, "Error al conectarse al servidor.")
        }

        if (error.response) {
          if (error.response.data.error === "invalid_grant")
            util.showDialogError(payload.context, 'Usuario y contraseña incorrectos.')
          reject(error.response)
        }
        reject(error)

      });
  });
};

const logout = ({ commit }, payload) => {
  return new Promise((resolve) => {
    localStorage.clear();
    commit('RESET_ALL', null, { root: true });

    payload.context.$router.push({ name: "login" });
    resolve();
  });
};

const updateUser = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    payload.context.axios.post('api/updateUser', payload.user, {'headers': util.getAuthHeader()}).then((response) => {

      commit('setUser', response.data)
      localStorage.setItem("user", JSON.stringify(response.data))

      resolve();

    }).catch(error => {
      if (error.response) {
        reject(error.response)
      }
      reject()
    });

  })
}

const setUser = ({commit}, payload) => {
  commit('setUser', payload)
}

const changePassword = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    payload.context.axios.put(`api/users/${payload.idUser}/changePass`, payload.form, {'headers': util.getAuthHeader()}).then((response) => {

      resolve(response.data);

    }).catch(error => {
      payload.context.$dialog.alert({
        title: 'Error',
        message: error.response.data.message,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      })

      reject(error.response)
    });
  })
}

export default {
  login,
  logout,
  updateUser,
  setUser,
  changePassword,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js